// Lightweight web haptic feedback via the Vibration API.
// No-ops where unsupported (desktop, iOS Safari); fires on Android tablets.
type Impact = 'light' | 'medium'

const DURATIONS: Record<Impact, number> = {
  light: 8,
  medium: 16,
}

export const haptic = (impact: Impact = 'light') => {
  navigator.vibrate?.(DURATIONS[impact])
}
